export type ItemFormValues = {
  name: string
  categories: string[]
}

export function toggleCategory(categories: string[], value: string): string[] {
  if (categories.includes(value)) {
    return removeCategory(categories, value)
  } else {
    return addCategory(categories, value)
  }
}

export function addCategory(categories: string[], value: string): string[] {
  return [...categories, value]
}

export function removeCategory(categories: string[], value: string): string[] {
  return categories.filter((v) => v !== value)
}
